import { useEffect, useState } from "react";
import Chart from "react-apexcharts";

import Spinner from "../../../common/Spinner/Spinner";

import { getDateOfISOWeek } from "../../../../utils/function";
import {
  formatDate,
  getDayDifference,
  getDecisionByLabel,
  getEndDateByStartDateStr,
  prepareData,
} from "../utils/statisticsUtil";

const countBySeverity = (list, severity) => {
  return list.map((columnData) => {
    return columnData[severity];
  });
};

export const StackedChart = ({
  data,
  dataLoading,
  filteringType,
  startDate,
  endDate,
  dataPointSelectionHandler,
}) => {
  const [series, setSeries] = useState([
    {
      name: "Malicious",
      data: data ? countBySeverity(data, "maliciousCount") : [],
    },
    {
      name: "Suspicious",
      data: data ? countBySeverity(data, "suspiciousCount") : [],
    },
    {
      name: "Clean",
      data: data ? countBySeverity(data, "cleanCount") : [],
    },
  ]);

  const [options, setOptions] = useState({
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: data.length ? true : false,
        },
      },
    },
    chart: {
      type: "bar",
      stacked: true,
      foreColor: "var(--header-search-text-color)",
      parentHeightOffset: 0,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      type: "datetime",
      categories: [],
      labels: {
        format: "dd MMM",
        showDuplicates: false,
      },
    },
    legend: {
      position: "bottom",
      offsetX: -10,
      offsetY: 10,
    },
    fill: {
      opacity: 1,
    },
    colors: ["#8b0000", "#F39C12", "#27AE60"],
    noData: {
      text: "No Data Found",
    },
  });

  useEffect(() => {
    let tempData = [];

    if (data && startDate && endDate) {
      tempData = prepareData(data, startDate, endDate, filteringType);
    }

    setOptions((options) => {
      return {
        ...options,
        chart: {
          ...options.chart,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const decisionLabel = config.w.config.series[config.seriesIndex].name;
              const decision = getDecisionByLabel(decisionLabel);
              const startDate = formatDate(
                new Date(config.w.config.xaxis.categories[config.dataPointIndex]),
              );
              const endDate = getEndDateByStartDateStr(startDate, filteringType);

              dataPointSelectionHandler(startDate, endDate, decision);
            },
          },
        },
        plotOptions: {
          ...options.plotOptions,
          bar: {
            ...options.plotOptions.bar,
            columnWidth:
              filteringType === "monthly"
                ? "45%"
                : filteringType === "daily" && getDayDifference(startDate, endDate) === 1
                ? "15%"
                : filteringType === "daily" && getDayDifference(startDate, endDate) === 2
                ? "30%"
                : filteringType === "daily" && getDayDifference(startDate, endDate) === 3
                ? "40%"
                : filteringType === "daily" && getDayDifference(startDate, endDate) <= 5
                ? "50%"
                : filteringType === "daily" && getDayDifference(startDate, endDate) <= 7
                ? "55%"
                : "70%",
          },
        },
        xaxis: {
          ...options.xaxis,
          categories: !tempData
            ? []
            : filteringType === "daily"
            ? tempData.map((columnData) => columnData._id)
            : filteringType === "weekly"
            ? tempData.map((columnData) => {
                const date = getDateOfISOWeek(columnData._id, columnData.year);

                var month = date.getMonth() + 1; //months from 1-12
                var day = date.getDate();
                var year = date.getFullYear();

                return `${year}-${month}-${day}`;
              })
            : filteringType === "monthly"
            ? tempData.map((columnData) => `${columnData._id.year}-${columnData._id.month}-1`)
            : [],
          labels: {
            ...options.xaxis.labels,
            format:
              filteringType === "daily"
                ? "dd MMM"
                : filteringType === "weekly" || filteringType === "monthly"
                ? "MMM yyyy"
                : "dd MMM",
          },
        },
        tooltip: {
          ...options.tooltip,
          x: {
            show: true,
            format:
              filteringType === "daily" || filteringType === "weekly"
                ? "d MMM yyyy"
                : filteringType === "monthly"
                ? "MMM yyyy"
                : "dd MMM",
          },
        },
      };
    });

    setSeries([
      {
        name: "Malicious",
        data: tempData ? countBySeverity(tempData, "maliciousCount") : [],
      },
      {
        name: "Suspicious",
        data: tempData ? countBySeverity(tempData, "suspiciousCount") : [],
      },
      {
        name: "Clean",
        data: tempData ? countBySeverity(tempData, "cleanCount") : [],
      },
    ]);
  }, [data]);

  return (
    <div style={{ width: "100%" }}>
      {dataLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "520px",
          }}>
          <Spinner />
        </div>
      ) : (
        <Chart options={options} series={series} type="bar" height={520} width={"100%"} />
      )}
    </div>
  );
};
